<template>
  <hb-basic-page
    :action-buttons="actionButtons"
    :back-button="backButton"
    :extension-height="$vuetify.breakpoint.smAndUp && $isTenantAdmin ? 47 : 47"
    :fill-height="loading"
    :loading="loading"
    :title="this.$route.params.id ? $t('project.edit_project') : $t('project.new_project')"
    style="background-color: transparent"
  >
    <v-col :style="{ marginBottom: $vuetify.breakpoint.xsOnly ? '76px' : '68px' }" class="pa-0" cols="12">
      <v-row no-gutters>
        <v-col
          :class="$vuetify.breakpoint.xsOnly ? 'gradient-icons pa-0 ma-0' : 'mt-5 gradient-icons'"
          lg="10"
          md="12"
          offset-lg="1"
          offset-md="0"
        >
          <v-card outlined>
            <v-card-title>
              {{ $tc('project.title', 1) }}
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="project.code"
                    :disabled="saving"
                    :label="$t('project.code')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                    item-value=""
                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="project.name"
                    :disabled="saving"
                    :label="$t('project.name')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                    item-value=""
                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="project.responsiblePerson"
                    :disabled="saving"
                    :label="$t('project.responsible_person')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details

                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <date-picker
                    v-model="project.estimatedStart"
                    :disabled="saving"
                    :input-styles="{
                        hideDetails: true,
                        light: true,
                        outlined: true,
                      }"
                    :label="$t('project.estimated_start')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                  >
                  </date-picker>
                </v-col>
                <v-col cols="12" md="4">
                  <date-picker
                    v-model="project.deliveryDate"
                    :disabled="saving"
                    :input-styles="{
                        dense: true,
                        hideDetails: true,
                        light: true,
                        outlined: true,
                      }"
                    :label="$t('project.delivery_date')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                  ></date-picker>
                </v-col>
                <v-col cols="12" md="4">

                  <date-picker
                    v-model="project.installationDate"
                    :disabled="saving"
                    :input-styles="{
                        dense: true,
                        hideDetails: true,
                        light: true,
                        outlined: true,
                      }"
                    :label="$t('project.installation_date')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                  ></date-picker>
                </v-col>

              </v-row>

              <v-row>
                <!--<v-col cols="12" md="4">

                  <date-picker
                    v-model="project.productionStartDate"
                    :disabled="saving"
                    :input-styles="{
                        hideDetails: true,
                        light: true,
                        outlined: true,
                      }"
                    :label="$t('project.production_start_date')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                  >
                  </date-picker>
                </v-col>
                <v-col cols="12" md="4">

                  <date-picker
                    v-model="project.productionEndDate"
                    :disabled="saving"
                    :input-styles="{
                        dense: true,
                        hideDetails: true,
                        light: true,
                        outlined: true,
                      }"
                    :label="$t('project.production_end_date')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details

                  >
                  </date-picker>

                </v-col>-->
                <v-col cols="12" md="4">


                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="4">
                  <v-autocomplete
                    v-model="project.status"
                    :disabled="saving"
                    :items="statuses"
                    :label="$t('project.status._')"
                    :readonly="false"
                    autocomplete="off"
                    dense
                    hide-details
                    item-text="label"
                    item-value="value"
                    light
                    outlined
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model.number="project.productionTime"
                    :disabled="saving"
                    :label="$t('project.production_time')"
                    autocomplete="off"
                    clearable
                    dense
                    hide-details

                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="4"><!--<v-checkbox
                      v-model="project.done"
                      :disabled="saving"
                      :label="$t('project.done')"
                      :readonly="true"
                      autocomplete="off"
                      dense
                      hide-details
                      light
                      outlined>
                  </v-checkbox>-->
                  <date-picker
                    v-model="project.estimatedEnd"
                    :disabled="saving"
                    :hint="$t('project.estimated_end_hint')"
                    :label="$t('project.estimated_end')"
                    :persistent-hint="true"
                    autocomplete="off"
                    clearable
                    dense
                    light
                    outlined
                  >
                  </date-picker>
                </v-col>


              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="project.deliveryAdditionalInfo"
                    :disabled="saving"
                    :label="$t('project.delivery_additional_info')"
                    auto-grow
                    autocomplete="off"
                    dense
                    hide-details
                    light
                    outlined
                    rows="2"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="project.roofType"
                    :disabled="saving"
                    :items="roofTypes"
                    :label="$t('project.roof_type')"
                    autocomplete="off"
                    clearable
                    dense
                    hide-details
                    item-text="label"
                    light
                    outlined

                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="project.cornerType"
                    :disabled="saving"
                    :items="cornerTypes"
                    :label="$t('project.corner_type')"
                    autocomplete="off"
                    clearable
                    dense
                    hide-details
                    item-text="label"
                    light
                    outlined

                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    v-model="project.foundationType"
                    :disabled="saving"
                    :items="foundationTypes"
                    :label="$t('project.foundation_type')"
                    autocomplete="off"
                    clearable
                    dense
                    hide-details
                    item-text="label"
                    light
                    outlined
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model.number="project.buildingModel"
                    :disabled="saving"
                    :label="$t('project.building_model')"
                    autocomplete="off"
                    clearable
                    dense
                    hide-details

                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-checkbox
                    v-model="project.noScheduling"
                    :disabled="saving"
                    :label="$t('project.no_scheduling')"

                    autocomplete="off"
                    dense
                    hide-details
                    light
                    outlined>
                  </v-checkbox>
                </v-col>
              </v-row>


            </v-card-text>
            <v-card-title>
              {{ $t('project.customer_info') }}
            </v-card-title>
            <v-card-text>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="project.deliveryRecipient"
                    :disabled="saving"
                    :label="$t('project.delivery_recipient')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="project.deliveryAddress"
                    :disabled="saving"
                    :label="$t('project.delivery_address')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    v-model="project.postalCode"
                    :disabled="saving"
                    :label="$t('project.postal_code')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="9">
                  <v-text-field
                    v-model="project.city"
                    :disabled="saving"
                    :label="$t('project.city')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="project.phone"
                    :disabled="saving"
                    :label="$t('project.phone')"
                    :readonly="true"
                    autocomplete="off"
                    dense
                    hide-details
                    item-value=""
                    light
                    outlined
                    validate-on-blur
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="project.email"
                    :disabled="saving"
                    :label="$t('project.email')"
                    :readonly="true"
                    :rules="[$rules.email, $rules.spacesNotAllowed]"
                    autocomplete="off"
                    dense
                    item-value=""
                    light
                    outlined
                    validate-on-blur
                  >
                  </v-text-field>
                </v-col>

              </v-row>

            </v-card-text>
          </v-card>

          <v-card class="mt-5" outlined>
            <v-card-title>
              {{ $t('project.logs._') }}
              <v-spacer/>
              <v-btn icon @click="addNewLog">
                <v-icon>mdi mdi-plus</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-for="(log,i) in project.logs">
                  <project-log-row :key="`${log.id}_${i}`"
                                   ref="projectLogRow"
                                   :log-suppliers="logSuppliers"
                                   :profiles="profiles"
                                   :project="project"
                                   :saving="saving"
                                   :statuses="statuses"
                                   :value="log"
                                   @input="(log) => onLogUpdate(log, i)"
                                   @edit-production-history="openProductionHistoryDialog"
                                   @delete-log="(log) => onDeleteLog(log, i)"
                  />

                </template>
              </v-simple-table>
              <production-history-dialog ref="productionHistoryDialog"
                                         @close="reloadProductionHistoryForProjectLog"></production-history-dialog>
              <delivery-dialog ref="deliveryDialog" @delivered="onDelivered" @cancelled="onDeliveryCancelled"></delivery-dialog>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
              <v-spacer/>
              <v-btn :loading="loadingHumidityReport" text @click="humidityReport">
                <v-icon>mdi mdi-file-chart-outline</v-icon>
                {{ $t('project.log_report') }}
              </v-btn>
            </v-card-actions>
          </v-card>
          <v-card class="mt-5" outlined>
            <v-card-title>
              {{ $t('project.site_contact_name') }}
            </v-card-title>
            <v-card-text>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="project.siteContactName"
                    :disabled="saving"
                    :label="$t('project.site_contact_name')"

                    autocomplete="off"
                    dense
                    hide-details
                    light
                    outlined
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="project.siteContactPhone"
                    :disabled="saving"
                    :label="$t('project.site_contact_phone_short')"

                    autocomplete="off"
                    dense
                    hide-details
                    item-value=""
                    light
                    outlined
                    validate-on-blur
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="project.siteContactEmail"
                    :disabled="saving"
                    :label="$t('project.site_contact_email_short')"

                    :rules="[$rules.email, $rules.spacesNotAllowed]"
                    autocomplete="off"
                    dense
                    item-value=""
                    light
                    outlined
                    validate-on-blur
                  >
                  </v-text-field>
                </v-col>

              </v-row>

            </v-card-text>
          </v-card>
          <project-contacts-card
            :contacts="project.contacts"
            :saving="saving"
            @add="addNewContact"
            @delete="deleteContact"
          />
          <project-readiness-card
            :project="project"
            :saving="saving"
          />
        </v-col>

      </v-row>
    </v-col>
  </hb-basic-page>
</template>

<script>
import projectApi from '@/api/project';
import DatePicker from "@/components/DatePicker.vue";
import ProjectLogRow from "@/components/Project/ProjectLogRow.vue";
import ProductionHistoryDialog from "@/components/Production/ProductionHistoryDialog.vue";
import DeliveryDialog from "@/components/Project/DeliveryDialog.vue";
import ProjectContactsCard from "@/components/Project/ProjectContactsCard.vue";
import ProjectReadinessCard from "@/components/Project/ProjectReadinessCard.vue";
import {v4 as uuidv4} from 'uuid';
import productionhistory from "@/api/productionhistory";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'
import dayjs from 'dayjs'
//import ProjectBlankWarehouseReceiptDialog from "@/components/Project/ProjectBlankWarehouseReceiptDialog.vue";

export default {
  name: 'ProjectView',
  components: {ProductionHistoryDialog, ProjectLogRow, DatePicker, DeliveryDialog, ProjectContactsCard, ProjectReadinessCard},
  data() {
    return {
      tab: 0,
      loading: false,
      loadingParties: false,
      loadingHumidityReport: false,
      searchPhrase: '',
      showAlert: false,
      backButton: {
        show: true,
        fallback: 'tenant_projects',
      },

      saving: false,
      project: {
        code: '',
        deliveryDate: null,
        estimatedStart: null,
        estimatedEnd: null,
        logs: [],
      },
      parties: [],
      logSuppliers: [
        {label: 'VAARA', value: 'VAARA'},
        {label: 'HONKA', value: 'HONKA'},
      ],
      profiles: [
        {label: 'Perinteinen', value: 'perinteinen'},
        {label: 'Design', value: 'design'},
      ],
      roofTypes: [
        {label: 'Harja', value: 'harja'},
        {label: 'Pulpetti', value: 'pulpetti'},
        {label: 'Tasakerta', value: 'tasakerta'},
      ],
      cornerTypes: [
        {label: 'Jiiri', value: 'jiiri'},
        {label: 'Risti', value: 'risti'},
        {label: 'Tiroli', value: 'tiroli'},
      ],
      foundationTypes: [
        {label: 'Pilari', value: 'pilari'},
        {label: 'Laatta', value: 'laatta'},
      ],
      previousStatus: null,

    };
  },
  watch: {
    'project.status'(newVal, oldVal) {
      if (newVal === 'DELIVERED' && oldVal !== 'DELIVERED' && oldVal !== null) {
        this.previousStatus = oldVal;
        this.openDeliveryDialog();
      }
    }
  },
  computed: {
    actionButtons() {
      return {
        save: {
          show: true,
          disabled: this.saving,
          callback: this.save,
          text: "Tallenna",
          primary: true,
          icon: 'mdi mdi-content-save',
        },
      }
    },
    statuses() {
      return projectApi.getProjectStatuses();
    },
  },
  methods: {
    addNewLog() {
      this.project.logs = [...this.project.logs, {
        code: '',
        description: '',
        logSupplier: '',
        profile: '',
        amount: null,
        status: this.project.status || 'CANT_START',
        productionTime: null,
      }];
    },
    addNewContact() {
      this.project.contacts = [...(this.project.contacts || []), {
        name: '',
        role: '',
        phone: '',
        email: '',
        description: '',
        _id: uuidv4(),
        _loading: false,
      }];
    },
    async deleteContact(contact) {
      if (await this.$confirmDelete(this.$t('project.contacts.delete_contact_text'), this.$t('project.contacts.delete_contact_text2'))) {
        contact._loading = true;
        if (contact.id) {
          try {
            await projectApi.deleteContact(this.project.id, contact.id);
            this.project.contacts = this.project.contacts?.filter(c => c._id !== contact._id) || [];
          } catch (e) {
            contact._loading = false;
            this.$showErrorNotification(this.$t('project.contacts.errors.delete'));
          }
        } else {
          this.project.contacts = this.project.contacts?.filter(c => c._id !== contact._id) || [];
        }

      }

    },
    reloadProductionHistoryForProjectLog(pl) {
      const plr = this.$refs.projectLogRow.find(p => p.log?.id === pl.id);
      plr?.getProductionHistory();
    },
    openProductionHistoryDialog(productionHistory) {
      this.$refs.productionHistoryDialog.openEdit(productionHistory)
    },
    openDeliveryDialog() {
      this.$refs.deliveryDialog.open(this.project);
    },
    onDelivered(deliveryData) {
      this.project.estimatedEnd = deliveryData.deliveryDate;
      this.project.deliveryAdditionalInfo = deliveryData.deliveryAdditionalInfo;
    },
    onDeliveryCancelled() {
      if (this.previousStatus) {
        this.project.status = this.previousStatus;
      }
    },
    async getProject() {
      this.loading = true;
      const project = await projectApi.getProject(this.$route.params.id);
      project.contacts = project.contacts?.map(c => ({...c, _id: uuidv4(), _loading: false}));
      this.project = project;
      this.loading = false;
      //
    },
    async save() {
      this.loading = true;


      try {
        await projectApi.saveProject(this.project);
        this.$showSuccessNotification(this.$t('project.updated'));
        await this.$router.push({name: 'tenant_projects'});
      } catch (e) {
        this.$showErrorNotification(this.$t('project.errors.update'));
      }

      this.loading = false;

    },
    onLogUpdate(log, i) {
      this.project.logs[i] = log;
    },
    onDeleteLog(log, i) {
      this.project.logs.splice(i, 1)
      //this.project.logs = this.project.logs.splice(i,1)
    },
    cancel() {
      this.$router.go(-1);
    },
    async humidityReport() {
      this.loadingHumidityReport = true;
      try {
        let doc = new jsPDF({putOnlyUsedFonts: true, orientation: 'portrait'});
        let logo = "data:image/png;base64,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";
        doc.addImage(logo, 'png', 10, 5, 52.17, 40);
        doc.setFontSize(16);
        doc.setFont("helvetica", "normal", "bold");
        doc.text("KOSTEUS-% RAPORTTI", 80, 20)
        doc.setFontSize(13);
        doc.text(this.project.code + ' - ' + this.project.name, 80, 30, {maxWidth: 120});
        doc.setFont("helvetica", "normal", "normal");
        let lastY = 50;
        let i = 0;
        for (let log of this.project.logs) {
          i++;
          const productionHistories = (await productionhistory.getPaged({searchString: null, projectLogId: log?.id}, {
            page: 1,
            itemsPerPage: 999
          }))?.content;

          let headers = [
            {dataKey: 'datetime', header: 'Päivämäärä'},
            {dataKey: 'humidity', header: 'Kosteus-%'}
          ];
          let humidities = productionHistories.filter(ph => ph?.humidity);
          let data = humidities.map(h => {
            return {
              'datetime': String(dayjs(h.startTime).format('DD.MM.YYYY HH:mm')) || '',
              'humidity': String(h?.humidity.toFixed(2) || '') + ' %',
            }
          });
          doc.setFontSize(12);
          doc.text((log?.log?.description || '') + ', ' + log?.amount + ' JM', 10, lastY);
          doc.setFontSize(10);
          autoTable(doc, {
            startY: lastY + 5,
            body: data,
            columns: headers,
            headStyles: {fillColor: null, textColor: '#000'},
            columnStyles: {humidity: {halign: 'right'}}
          });
          if (i < this.project.logs?.length) doc.addPage();
          lastY = 20
        }
        doc.save((this.project.code + ' - ' + this.project.name + ' - Kosteus-raportti').replace(/[^a-zA-ZäöÄÖåÅ0-9._-]/g, '') + '.pdf');
      } catch (e) {
        console.error(e);
        this.$showErrorNotification("Virhe muodostettaessa PDF-tiedostoa");
      }
      this.loadingHumidityReport = false;
    }

  },
  async mounted() {
    if (!this.$hasMatchingTenantRoles(['tenant_admin', 'tenant_office', 'tenant_basic'])) {
      this.$router.replace({name: 'access_denied'});
      return;
    }

    if (this.$route.params.id) {
      await this.getProject();
    }

  },
};
</script>

<style scoped>
.v-tabs-items {
  background-color: transparent !important;
}

.toggle_group_buttons {
  height: 48px !important;
  width: 50% !important;
}

</style>
